<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/package/index">我的套餐</el-breadcrumb-item>
        <el-breadcrumb-item>{{ courseInfo.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button size="small" class="reback" type="primary" icon="el-icon-refresh-left" @click="back()">返回列表
      </el-button>
    </el-col>
    <div class="content">
      <div class="xcx-content flex" v-loading="loading">
        <div class="flex-grow bg-w">
          <div class="box-border pt20 pb20 border-b-s flex text-default">
            <div class="mr20" style="width: 150px;">
              <img class="thumb_images" :src="courseInfo.thumb" alt="">
            </div>
            <div class="x">
              <div class="mb10">
                <span class="text-default ft26">{{ courseInfo.title }}</span>
              </div>
              <div class="flex">
                <div class="ft14 text-tags pl10 pr10 pd5 bdr4 border-tags mr10">
                  到期时间：{{ courseInfo.last_date }}</div>
              </div>
            </div>
          </div>

          <div class="pt20 pb20">

            <el-empty :image-size="200" v-if="packageAttr.length == 0"></el-empty>
            <div v-else>
              <div class="flex mb20">
                <!-- <div class="year-tags active">年份：</div> -->
                <div @click="clickNavYear(item)" class="year-tags" :class="year == item ? 'active' : ''"
                  v-for="(item, idx) in years" :key="idx">{{
                    item }}年</div>
              </div>
              <div class="xx">
                <div v-if="v.course.length || v.download.length" class="bg-F9F9F flex space box-border pl10 pr10 mb10"
                  v-for="(v, i) in packageAttr" :key="i">
                  <div class="flex-grow flex text-6F8199 ft16 text-over shline" @click="unfold(v, i)">
                    <div class="truncate1" :title="v.title">{{ v.title }}</div>
                    <div class="zz">
                      {{ v.check == true ? '收起' : '展开' }}
                      <img src="../../../public/images/down_00.png" v-if="v.check == false" />
                      <img src="../../../public/images/down_01.png" v-else />
                    </div>
                  </div>

                  <div style="display: flex;flex-wrap: wrap;justify-content: space-between;" v-if="v.check">
                    <div class="data-item h90 dis_jcsb border-bottom cur_p flex" v-for="(n, j) in v.download" :key="j">
                      <div class="flex txt-6F8199 font16 col7">
                        <img class="w42 mr25" src="../../../public/images/icon/21.png" alt="" />
                        <div class="col1">
                          <div class="data-item-title txt-233650 font16 truncate">{{ n.title }}</div>
                          <div class="txt-9097AB font14 mt15">
                            <span class="mr60">更新时间：{{ n.updated_at }}</span>
                            <span class="mr60">{{ adminApi.bytesToMBDecimal(n.size) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="">
                        <!-- <el-button @click="downLoadFile(n, 0)" type="primary" round icon="el-icon-view">预览
                        </el-button> -->
                        <el-button @click="downLoadFile(n, 1)" type="danger" round icon="el-icon-download">下载
                        </el-button>
                      </div>
                    </div>
                  </div>

                  <el-row :gutter="20" v-if="v.check">
                    <el-col :span="3" v-for="(o, index) in v.course" :key="index" class="mb20"
                      :offset="index > 0 ? 0 : 0">
                      <el-card :body-style="{ padding: '0px' }" class="cur_p" style="position: relative;">
                        <img :src="o.thumb" class="image" @click="goDetails(o.id, o.pack_id)">
                        <div style="padding: 14px;" @click="goDetails(o.pack_id, o.id)">
                          <span>{{ o.title }}</span>
                        </div>
                        <div class="live" v-if="o.type == 1">直播课</div>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="sgxjc" @click="goSgxjc()" v-if="courseInfo.column_id == 65 || courseInfo.column_id == 66">
        <img src="https://imgs.jianjiangedu.cn/2026-03-18/sjBqjmr9j6VblyeR435xA5cR1Z8fY67mP1hsyL2a.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: 0,
      pack_id: 0,
      currentYear: 0,
      courseInfo: [],
      packageAttr: [],
      teacherInfo: [],
      years: [],
      idx: 0,
      year: 2026,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.pack_id = query.pack_id;
      that.year = query.year;
      that.getDetail();
    }
  },
  methods: {

    goSgxjc() {
      var user = sessionStorage.getItem('access-users');
      var users = JSON.parse(user);
      //console.log(users);
      window.open("https://www.yitku.com/m/social33?column_id=65&subject_id=199&province_id=&uid=" + users['id'], '_blank');
      //window.location.href = "https://www.yitku.com/m/social33?column_id=65&subject_id=199&province_id=&uid=" + users['id'];
    },

    clickNavYear(y) {
      this.year = y;
      this.getDetail();
    },

    unfold(v, idx) {
      const index = idx;
      const newUserList = [...this.packageAttr];
      newUserList[index].check = !newUserList[index].check;
      this.packageAttr = newUserList;
    },

    downLoadFile(v, s) {
      let that = this;
      that.axios.post("/getDownloadUrl", { id: v.id }).then((res) => {
        if (res.code == 200) {
          if (s == 1) {
            window.open(res.data.urls);
          } else {
            window.open(res.data.filepath);
          }
        } else {
          that.$message({
            type: "error",
            message: `操作提示: ${res.msg}`,
          });
          return;
        }
      });
    },

    goDetails(ids) {
      this.$router.push({
        path: "/course/details",
        query: {
          id: ids,
          pack_id: this.pack_id,
          ids: this.id
        },
      });
    },
    /**
     * 获取列表
     */
    getDetail() {
      let that = this;
      that.axios.post("/getPackageDetail", { id: that.pack_id, pack_id: that.id, years: that.year }).then((res) => {
        if (res) {
          that.courseInfo = res.data;
          that.years = res.data.years;
          that.packageAttr = res.data.attr;
          for (let i = 0; i < that.packageAttr.length; i++) {
            that.packageAttr[i].check = false
            // if (i == 0) {
            //   that.packageAttr[i].check = true
            // } else {
            //   that.packageAttr[i].check = false
            // }
          }

          for (let i = 0; i < that.packageAttr.length; i++) {
            if (that.packageAttr[i].course.length || that.packageAttr[i].download.length) {
              that.packageAttr[i].check = true;
              break
            }
          }

          that.loading = false;
        }
      });
    },

    back() {
      this.$router.push("/package/index");
    },
  },
};
</script>
<style>
.sgxjc {
  width: 75px;
  height: 71px;
  position: absolute;
  top: 60px;
  right: 20px;
  cursor: pointer;
}

.sgxjc img {
  width: 75px;
  height: 71px;
}


.live {
  font-size: 12px;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(90deg, #F8433A, #FF7869);
  color: #fff;
  padding: 3px 8px;
  border-radius: 5px 0 5px 0;
}

.flex-grow {
  flex-grow: 1;
}

.thumb_images {
  width: 100%;
  height: 80px;
  border-radius: 5px;
}

.border-tags {
  border: 1px solid #c18958;
}

.text-tags {
  color: #c18958;
}

.bg-F9F9F {
  background: #f9f9f9;
  flex-direction: column;
}

.image {
  width: 183px;
  height: 214px;
  display: block;
}

.text-6F8199 {
  color: #6f8199;
}

.truncate1 {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 60px;
  line-height: 60px;
}

.border-sub {
  border: 1px solid #cccccc;
}

.year-tags {
  background-color: #f0f3f7;
  color: #233650;
  width: 106px;
  height: 42px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
}

.year-tags.active {
  background-color: #3078ff;
  color: #fff;
  position: relative;
}

.el-card span {
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.w42 {
  width: 43px;
  height: 52px;
}

.data-item:hover {
  color: #3078FF;
  background: #F0F3F7;
}

.txt-6F8199 {
  color: #6F8199;
}

.txt-9097AB {
  color: #9097AB;
}

.border-bottom {
  border-bottom: 1px #ccc dashed;
}

.h90 {
  height: 90px;
  width: 48%;
}

.shline {
  border-bottom: 8px solid #ffffff;
  margin-bottom: 10px;
  cursor: pointer;
}

.zz {
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #666666;
  width: 3%;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}

.zz img {
  width: 12px;
  height: 13px;
  margin-left: 5px;
}
</style>